import { render, staticRenderFns } from "./PinnedMessagesPanel.vue?vue&type=template&id=2b5d0ff9"
import script from "./PinnedMessagesPanel.vue?vue&type=script&lang=js"
export * from "./PinnedMessagesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports